{
  "accountLandingLinkTo": "Account",
  "accountLandingTitle": "Impostazioni dell'account",
  "accountSettingsTitle": "Impostazioni dell'account",
  "activeFarmTitle": "Fattoria attiva",
  "adminModeToggle": "Modalità amministratore",
  "adminUser": "Utente amministratore",
  "adminUserIndicatorWithEmail": "{{email}} (Utente amministratore)",
  "appInfoClearCache": "Cancella cache",
  "appInfoExpireFarmCache": "Aggiorna cache dei dati dell'azienda",
  "appInfoExpireFarmCacheSuccess": "Cache dei dati dell'azienda aggiornata",
  "appInfoIsDemoModeActive": "Modalità demo abilitata",
  "appInfoLinkTo": "Informazioni sull'app",
  "appInfoTitle": "Informazioni sull'app",
  "appInfoUpdateId": "Aggiorna ID",
  "appInfoVersion": "Versione",
  "appNotificationsLinkTo": "Annunci",
  "appNotificationsListEmpty": "Nessun annuncio al momento. Ricontrolla più tardi.",
  "appNotificationsTitle": "Annunci",
  "appPreferences": "Preferenze dell'app",
  "changeFarmsListActiveDevicesWithItemCount": "{{itemCount}} dispositivi attivi",
  "changeFarmsListListEmpty": "Il tuo account non è collegato ad alcuna fattoria attiva.",
  "changeFarmsListSubheaderwithFarmName": "Azienda agricola attiva: {{farmName}}",
  "changeFarmsListTitle": "I tuoi conti agricoli",
  "checkForUpdatesButtonText": "Controlla gli aggiornamenti",
  "checkForUpdatesError": "Errore durante il recupero dell'ultimo aggiornamento dell'app",
  "yourAppIsUpToDate": "La tua app è aggiornata",
  "checkForUpdatesYourAppIsUpToDate": "La tua app è aggiornata",
  "companySectionTitle": "Chi siamo",
  "contactUsLink": "Contattaci",
  "crashButton": "Incidente",
  "darkModeToggle": "Modalità scura",
  "farmJoinCodeTitle": "Codice di adesione alla fattoria",
  "farmUsersListLink": "Utenti della fattoria",
  "internalOnlySectionTitle": "Solo interno",
  "linkTo": "Account",
  "measurementPreferenceLabel": "Misure",
  "measurementPreferenceValues": {
    "metric": "Metrico",
    "us": "U.S.A."
  },
  "nameFirstInputLabel": "Nome di battesimo",
  "nameFirstInputPlaceholder": "(Inserisci il tuo nome)",
  "nameLastInputLabel": "Cognome",
  "nameLastInputPlaceholder": "(Inserisci il tuo cognome)",
  "newFarmAccount": "Nuovo account agricolo",
  "phoneNumbersListLink": "Numeri di telefono",
  "shareFeedbackLink": "Condividi feedback",
  "supportedLanguages": {
    "en": "🇺🇸 Inglese (Stati Uniti)",
    "es": "🇲🇽 Spagnolo (MX)",
    "fr": "🇫🇷 Francese",
    "it": "🇮🇹 Italiano"
  },
  "supportedLanguagesTitle": "Lingua preferita",
  "userAccountTitle": "Il mio conto",
  "userFarmsListLinkTo": "I tuoi conti agricoli",
  "userFarmsListListEmpty": "Il tuo account non è collegato ad alcuna fattoria attiva.",
  "userFarmsListNoOtherFarms": "Il tuo account non è collegato ad altre fattorie",
  "userFarmsListSubheaderWithActiveFarmName": "Azienda agricola attiva: {{activeFarmName}}",
  "userFarmsListTitle": "I tuoi conti agricoli",
  "userNameFormCollectionDisclaimer": "Raccogliamo queste informazioni per tracciare chi sono i nostri clienti e per fornire la migliore esperienza di servizio clienti possibile. Non condividiamo queste informazioni con terze parti.",
  "userNameFormCollectionTitle": "Raccolta dati: Nome utente",
  "userNameFormInstructions": "Per offrirti la migliore esperienza possibile di servizio clienti, abbiamo bisogno di alcune informazioni da parte tua:",
  "userNameFormTitle": "Nome utente",
  "userNameWithNameGivenAndNameFamily": "{{nameGiven}} {{nameFamily}}",
  "viewDebugInfoButton": "Visualizza informazioni di debug",
  "viewFarmUserPermissionsLinkTo": "Visualizza i tuoi permessi",
  "viewFarmUserPermissionsTitle": "I tuoi permessi",
  "viewPrivacyPolicyLinkTo": "Visualizza l'Informativa sulla privacy",
  "viewPrivacyPolicyTitle": "politica sulla riservatezza",
  "deleteAccountLinkTo": "Elimina account",
  "deleteAccountTitle": "Elimina account",
  "deleteAccountWarning": "Questa azione è permanente e non può essere annullata. Il tuo account verrà disattivato, le tue informazioni personali verranno rimosse e verrai disconnesso.",
  "deleteAccountConfirmationLabel": "Digita DELETE per confermare",
  "deleteAccountConfirmationPlaceholder": "DELETE",
  "deleteAccountConfirmButton": "Elimina il mio account",
  "deleteAccountOwnedFarmsWarning": "Devi trasferire la proprietà o disattivare le seguenti aziende agricole prima di eliminare il tuo account:",
  "transferOwnershipLinkTo": "Trasferisci proprietà",
  "transferOwnershipTitle": "Trasferisci proprietà dell'azienda agricola",
  "transferOwnershipDescription": "Seleziona un membro dell'azienda agricola per diventare il nuovo proprietario.",
  "transferOwnershipSuccess": "Proprietà trasferita con successo.",
  "deactivateFarmLinkTo": "Disattiva azienda agricola",
  "deactivateFarmTitle": "Disattiva azienda agricola",
  "deactivateFarmWarning": "Questo disattiverà l'azienda agricola, rimuoverà l'accesso di tutti i membri e rilascerà tutti i dispositivi.",
  "deactivateFarmConfirmButton": "Disattiva azienda agricola",
  "leaveFarmLinkTo": "Lascia l'azienda agricola",
  "leaveFarmConfirmMessage": "Sei sicuro di voler lasciare questa azienda agricola?",
  "leaveFarmConfirmButton": "Lascia l'azienda agricola"
}
